import { render, staticRenderFns } from "./EntityDetailedCardView.vue?vue&type=template&id=68bf8d44&scoped=true"
import script from "./EntityDetailedCardView.vue?vue&type=script&lang=js"
export * from "./EntityDetailedCardView.vue?vue&type=script&lang=js"
import style0 from "./EntityDetailedCardView.vue?vue&type=style&index=0&id=68bf8d44&prod&lang=scss&scoped=true"
import style1 from "./EntityDetailedCardView.vue?vue&type=style&index=1&id=68bf8d44&prod&lang=css"
import style2 from "./EntityDetailedCardView.vue?vue&type=style&index=2&id=68bf8d44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bf8d44",
  null
  
)

export default component.exports